export const QQMapKey = 'LOMBZ-O4FC5-KX2IK-IARQT-EXUS5-74BR3'

export const createQQmapScripit = () => {
      //腾讯地图使用
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `https://map.qq.com/api/gljs?libraries=tools,service&v=1.exp&key=${QQMapKey}`;
      document.head.appendChild(script);
}